"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_AdverseEvent = exports.AdverseEventActualityKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_AdverseEvent_SuspectEntity_1 = require("./RTTI_AdverseEvent_SuspectEntity");
var AdverseEventActualityKind;
(function (AdverseEventActualityKind) {
    AdverseEventActualityKind["_actual"] = "actual";
    AdverseEventActualityKind["_potential"] = "potential";
})(AdverseEventActualityKind = exports.AdverseEventActualityKind || (exports.AdverseEventActualityKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_AdverseEvent = t.recursion('IAdverseEvent', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('AdverseEvent'),
            subject: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: RTTI_Identifier_1.RTTI_Identifier,
            actuality: (0, EnumType_1.createEnumType)(AdverseEventActualityKind, 'AdverseEventActualityKind'),
            _actuality: RTTI_Element_1.RTTI_Element,
            category: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            event: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            encounter: RTTI_Reference_1.RTTI_Reference,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            detected: RTTI_dateTime_1.RTTI_dateTime,
            _detected: RTTI_Element_1.RTTI_Element,
            recordedDate: RTTI_dateTime_1.RTTI_dateTime,
            _recordedDate: RTTI_Element_1.RTTI_Element,
            resultingCondition: t.array(RTTI_Reference_1.RTTI_Reference),
            location: RTTI_Reference_1.RTTI_Reference,
            seriousness: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            severity: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            outcome: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            recorder: RTTI_Reference_1.RTTI_Reference,
            contributor: t.array(RTTI_Reference_1.RTTI_Reference),
            suspectEntity: t.array(RTTI_AdverseEvent_SuspectEntity_1.RTTI_AdverseEvent_SuspectEntity),
            subjectMedicalHistory: t.array(RTTI_Reference_1.RTTI_Reference),
            referenceDocument: t.array(RTTI_Reference_1.RTTI_Reference),
            study: t.array(RTTI_Reference_1.RTTI_Reference)
        })
    ]);
});
//# sourceMappingURL=RTTI_AdverseEvent.js.map